module.exports = __webpack_public_path__ + "src/assets/img/cmdProg5.32443a3c.svg";